module.exports = __webpack_public_path__ + "img/fail.afac3b85.png";